import { z } from 'zod';

import { SMALL_STRING_LIMIT } from './constants';

export type Document = {
  type: 'Document';
  metadata?: Record<string, unknown>;
  page_content: string;
};

export const zDocument = z.object({
  type: z.literal('Document'),
  metadata: z.record(z.unknown()),
  page_content: z.string(),
});

export const zDocuments = z.array(zDocument).min(1);

export const isDocumentSmall = (doc: Document): boolean => {
  return doc.page_content.length < SMALL_STRING_LIMIT;
};
